export const formsUk: Record<string, string> = {
  "order.service.audit_free": "Безкоштовний DevOps аудит (30-хвилинний дзвінок)",
  "order.service.starter_devops": "Starter DevOps - $1,500/місяць (30 годин, SLA 8 год)",
  "order.service.growth_devops": "Growth DevOps - $3,000/місяць (80 годин, SLA 4 год) 🏆",
  "order.service.enterprise_devops": "Enterprise DevOps - $5,000/місяць (160 годин, SLA 1 год)",
  "order.service.k8s_setup": "Kubernetes Setup - $3,000–7,000 (одноразово)",
  "order.service.k8s_managed": "Kubernetes Managed - від $500/місяць",
  "order.service.vps_hosting": "VPS-хостинг — від $7.62 на місяць (CX23, білінг)",
  "order.service.devops_estimate": "Оцінка вартості DevOps",
  "order.service.ddos_protection": "Захист від DDoS",
  "order.service.cicd_implementation": "Впровадження CI/CD",
  "order.service.llmops_private_ai": "LLMOps & Private AI — проєкт під ключ (Fixed Price)",
  "order.service.devops_general": "DevOps аутсорсинг (загальний запит)",
  "order.service.support_247": "Підтримка серверів 24/7 (загальний запит)",

  "order.pageTitle": "Безкоштовний аудит DevOps-інфраструктури",
  "order.pageSubtitle":
    "Отримайте детальний аналіз вашої IT-інфраструктури та дізнайтесь, як DevOps аутсорсинг може зменшити витрати до 60% вже в перший місяць",
  "order.formTitle": "Форма безкоштовного аудиту DevOps",
  "order.formIntro":
    "Два поля — і ми зв'яжемося з вами. Без довгих опитувань і зобов'язань.",
  "order.label.name": "Ім'я *",
  "order.label.email": "Email *",
  "order.label.phone": "Телефон",
  "order.label.company": "Компанія",
  "order.label.service": "Цікава послуга *",
  "order.label.projectType": "Оберіть тип проєкту *",
  "order.label.contact": "Ваш Telegram / WhatsApp для зв'язку *",
  "order.label.message": "Повідомлення",
  "order.ph.name": "Ваше ім'я",
  "order.ph.email": "your@email.com",
  "order.ph.phone": "+380",
  "order.ph.company": "Назва компанії",
  "order.ph.service": "Оберіть послугу",
  "order.ph.projectType": "Оберіть тип проєкту",
  "order.ph.contact": "@username або +380 XX XXX XX XX",
  "order.ph.message": "Опишіть ваші задачі або проблеми...",
  "order.hint.contact": "Проведемо 15-хвилинний розбір вашого стеку без зобов'язань.",
  "order.submit": "Отримати безкоштовний розбір",
  "order.sending": "Надсилання...",
  "order.successTitle": "Аудит інфраструктури замовлено!",
  "order.successText":
    "Дякуємо! Ми отримали вашу заявку. Наш DevOps експерт зв'яжеться з вами протягом 24 годин для безкоштовного аудиту та розрахунку потенційної економії.",
  "order.successAgain": "Замовити ще один аудит",
  "order.mailtoFallback":
    "Поштовий клієнт не відкрився. Надішліть заявку на email або напишіть у Telegram — відповімо протягом 24 годин.",
  "order.backServices": "Повернутись до послуг",
  "order.contactTitle": "Зв'язатись з нами",
  "order.contactEmail": "Email",
  "order.contactTg": "Telegram",
  "order.contactPhone": "Телефон",
  "order.benefitsTitle": "Що ви отримаєте?",
  "order.benefit1": "✅ Детальний аналіз інфраструктури",
  "order.benefit2": "✅ Розрахунок потенційної економії",
  "order.benefit3": "✅ Рекомендації з оптимізації",
  "order.benefit4": "✅ План впровадження DevOps",
  "order.benefit5": "✅ Оцінка вартості послуг",
  "order.responseTitle": "Час відповіді",
  "order.responseText":
    "Ми відповідаємо на всі заявки протягом 2 годин у робочий час (Пн-Пт, 9:00-18:00 за Києвом).",
  "order.mail.subject": "Нове замовлення з сайту IT-24.pro",
  "order.mail.infoSubject": "Запит інформації про DevOps послуги",
  "order.mail.bodyTitle": "🔔 Нове замовлення з сайту IT-24.pro",
  "order.mail.name": "👤 Ім'я",
  "order.mail.email": "📧 Email",
  "order.mail.phone": "📱 Телефон",
  "order.mail.contact": "💬 Telegram / WhatsApp",
  "order.mail.company": "🏢 Компанія",
  "order.mail.service": "🛠️ Послуга",
  "order.mail.message": "💬 Повідомлення",
  "order.mail.time": "⏰ Час",
  "order.mail.na": "Не вказано",
  "order.mail.naF": "Не вказано",
  "order.mail.naMsg": "Не вказано",
  "order.errorSend": "Помилка надсилання. Спробуйте пізніше або зв'яжіться з нами напряму.",

  "contacts.title": "Зв'яжіться з нами",
  "contacts.subtitle":
    "Готові обговорити проєкт? Оберіть зручний спосіб зв'язку або заповніть форму зворотного зв'язку",
  "contacts.card.phoneTitle": "Телефон",
  "contacts.card.phoneDesc":
    "Полюбляєте живе спілкування? Зателефонуйте нам, щоб оперативно обговорити питання та наступні кроки.",
  "contacts.card.mailTitle": "Електронна пошта",
  "contacts.card.mailDesc":
    "Напишіть на пошту з описом задач або проблем. Ми швидко відповімо й запропонуємо рішення.",
  "contacts.card.tgTitle": "Telegram",
  "contacts.card.tgDesc":
    "Напишіть у Telegram для швидкої відповіді та миттєвої підтримки.",
  "contacts.card.formTitle": "Форма зворотного зв'язку",
  "contacts.card.formValue": "Онлайн заявка",
  "contacts.card.formDesc":
    "Заповніть форму на сайті для швидкої відповіді. Вкажіть контакти та короткий опис задачі чи проєкту.",
  "contacts.formTitle": "Форма зворотного зв'язку",
  "contacts.label.subject": "Тема *",
  "contacts.ph.subject": "Тема повідомлення",
  "contacts.ph.message": "Опишіть ваші задачі або питання...",
  "contacts.send": "Надіслати повідомлення",
  "contacts.successTitle": "Повідомлення надіслано!",
  "contacts.successText": "Дякуємо за повідомлення! Ми отримали його і зв'яжемось найближчим часом.",
  "contacts.sendAgain": "Надіслати ще одне повідомлення",
  "contacts.hoursTitle": "Робочі години",
  "contacts.hoursNote": "⚡ Екстрена підтримка доступна 24/7 для критичних інцидентів",
  "contacts.addrTitle": "Адреса",
  "contacts.addrLine": "Україна, Київ",
  "contacts.addrNote": "Працюємо віддалено по всій Україні та країнах СНД",
  "contacts.sosTitle": "🚨 Екстрена підтримка",
  "contacts.sosText": "Критичний інцидент? Потрібна негайна допомога?",
  "contacts.sosCall": "Терміновий дзвінок",
  "contacts.sosTg": "Telegram SOS",
  "contacts.mail.subjectPrefix": "Повідомлення з сайту IT-24.pro:",
  "contacts.mail.bodyTitle": "🔔 Нове повідомлення з сайту IT-24.pro",
  "contacts.mail.subjectLine": "📋 Тема",
  "contacts.subjectForService": "Запит щодо послуги",
  "contacts.day1": "Понеділок - П'ятниця",
  "contacts.day2": "Субота",
  "contacts.day3": "Неділя",
  "contacts.time1": "9:00 - 18:00",
  "contacts.time2": "10:00 - 16:00",
  "contacts.time3": "За домовленістю",
};
